export default function SiteFooter({ className = '' }) {
  return (
    <footer className={`site-footer ${className}`.trim()}>
      <small>Copyright (c) {new Date().getFullYear()} SabayBuy</small>
      <a href="/privacy-policy">Privacy Policy</a>
      <a href="/terms.html">Terms of Service</a>
      <a href="/prohibited-items.html">Prohibited Items</a>
      <a href="mailto:support@sabaybuy.ph">Support</a>
    </footer>
  );
}
